<app-documentation *ngIf="pageId == 'documentation'" [userInfos]="userInfos"></app-documentation>
<app-user-admin *ngIf="pageId == 'user-admin'" [userInfos]="userInfos"></app-user-admin>
<app-server-admin *ngIf="pageId == 'server-admin'" [userInfos]="userInfos"></app-server-admin>
<app-management *ngIf="pageId == 'management'" [userInfos]="userInfos"></app-management>